module.exports = __webpack_public_path__ + "img/no_dataImg.ec424d73.png";